"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGridFilterViewItems = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const ExpressionPreview_1 = require("../../../components/ExpressionEditor/ExpressionPreview");
const Tag_1 = require("../../../components/Tag");
const getGridFilterViewItems = (layout) => {
    var _a;
    return {
        name: 'Grid Filters',
        view: (React.createElement(Tag_1.Tag, null,
            React.createElement(ExpressionPreview_1.ExpressionPreview, { query: { BooleanExpression: (_a = layout.GridFilter) === null || _a === void 0 ? void 0 : _a.Expression } }))),
    };
};
exports.getGridFilterViewItems = getGridFilterViewItems;
